// profile/ProfileTabContent.jsx
import React from 'react';
import UpcomingEvents from './UpcomingEvents';
import PastEvents from './PastEvents';
import Gallery from './Gallery';
import PurchasedEvents from './PurchasedEvents';
import styles from './styles/ProfileTabContent.module.css';
import { TAB } from './tabs';

const ProfileTabContent = ({ user, isOwner, activeTab }) => {
  return (
    <div className={styles.tabContent}>
      <div className={styles.content}>
        {activeTab === TAB.UPCOMING && <UpcomingEvents user={user} isOwner={isOwner} />}
        {activeTab === TAB.PAST && <PastEvents user={user} isOwner={isOwner} />}
        {activeTab === TAB.GALLERY && <Gallery user={user} />}
        {activeTab === TAB.PURCHASED && <PurchasedEvents user={user} isOwner={isOwner} />}
      </div>
    </div>
  );
};

export default ProfileTabContent;
